import React from "react";

const Loader = (prop) => {
  return prop.width ? <img alt="loading" src="/assets/images/loader.svg" width={prop.width}/> :
  <img alt="loading" src="/assets/images/loader.svg" />;
};

export default Loader;
